import type { HighPrecisionMonotonicClock } from '../types/highPrecisionMonotonicClock';

export function makeNodeJsHighPrecisionMonotonicClock(hrtime: NodeJS.HRTime | undefined): HighPrecisionMonotonicClock | null {
  // Its better to do this check inside this utility since the typesystem does
  // not always reflect correctly whether hrtime is defined or not.
  if (hrtime === undefined) {
    return null;
  }

  if (typeof hrtime?.bigint === 'function') {
    return {
      highPrecisionMonotonicNow(): bigint {
        return hrtime.bigint();
      }
    };
  }

  if (typeof hrtime === 'function') {
    return {
      highPrecisionMonotonicNow(): bigint {
        const NS_PER_SECOND = BigInt(10e9);
        const [seconds, nsseconds] = hrtime();
        return (BigInt(seconds) * NS_PER_SECOND) + BigInt(nsseconds);
      }
    };
  }

  return null;
}
